import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import { makeStyles } from "@material-ui/core/styles";

import {
  FormLabel,
  Input,
  Select,
  MenuItem,
  Checkbox,
  ListItemText
} from "@material-ui/core";

import {
  setDynamicTargetingKeys
} from "../../../actions/app/creatives";

import { fetchDynamicTargetingKeys } from "../../../actions/dcm/dynamicTargetingKeys";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    flexWrap: "wrap",
    margin: theme.spacing(2),
    width: "calc(100% - 48px)"
  },
  select: {
    marginRight: theme.spacing(1),
    marginTop: theme.spacing(2),
    width: "100%"
  },
  label: {
    marginTop: theme.spacing(1),
  },
}));

export default function DynamicTargetingKeys() {
  const classes = useStyles();
  const dispatch = useDispatch();

  let campaigns = useSelector(state => state.dcmCampaigns);
  let dynamicTargetingKeys = useSelector(state => state.dcmDynamicTargetingKeys);

  const selectedKeys = useSelector(
    (state) => state.creatives.dynamicTargetingKeys
  );

  const advertiserId = campaigns.byId[campaigns.selectedId].advertiserId;

  useEffect(() => {
    dispatch(
        fetchDynamicTargetingKeys(
        advertiserId
      )
    );
  }, [advertiserId, dispatch]);

  const handleChange = (event) => {
    dispatch(setDynamicTargetingKeys(event.target.value));
  };

  return (
    <form className={classes.container} noValidate>
      <FormLabel component="legend" className={classes.label}>
        Dynamic Targeting Keys
      </FormLabel>
      <Select
        className={classes.select}
        id="dynamicTargetingKeys"
        multiple
        value={selectedKeys}
        onChange={handleChange}
        renderValue={(selected) => selected.map(s => s.name).join(', ')}
        input={<Input />}
      >
        {dynamicTargetingKeys.data.map((dtk) => (
          <MenuItem key={dtk.name} value={dtk}>
            <Checkbox checked={selectedKeys.indexOf(dtk) > -1} />
            <ListItemText primary={dtk.name} />
          </MenuItem>
        ))}
      </Select>
    </form>
  );
}
